import React, { FC } from 'react';
import { Tabs as RBTabs, Tab } from 'react-bootstrap';
import classNames from 'classnames';

import './Tabs.scss';

export interface ITabProps {
  title: string;
  key: string;
  content?: JSX.Element | JSX.Element[];
}

export interface ITabsProps {
  className?: string;
  defaultActiveKey?: string;
  activeKey?: string;
  setActiveKey?: React.Dispatch<React.SetStateAction<string>> | (() => void);
  setTabInQuery?: (
    nextInit: any,
    navigateOptions?:
      | {
          replace?: boolean | undefined;
          state?: any;
        }
      | undefined,
  ) => void;
  id: string;
  tabs?: ITabProps[];
}

const Tabs: FC<ITabsProps> = (props) => {
  const { activeKey, className, defaultActiveKey, id, tabs, setActiveKey, setTabInQuery } = props;
  return (
    <RBTabs
      activeKey={activeKey}
      className={classNames('PraktioTabs mb-4', className)}
      defaultActiveKey={defaultActiveKey}
      id={id}
      transition={false}
      onSelect={(key) => {
        if (key) {
          if (setTabInQuery) {
            setTabInQuery({ tab: key });
          } else if (setActiveKey) {
            setActiveKey(key);
          }
        }
      }}
    >
      {tabs?.map((tab, i) => (
        <Tab key={tab.key + i} title={tab.title} eventKey={tab.key}>
          {tab.content}
        </Tab>
      ))}
    </RBTabs>
  );
};

Tabs.defaultProps = {
  className: undefined,
  tabs: undefined,
  defaultActiveKey: undefined,
  activeKey: undefined,
  setActiveKey: undefined,
  setTabInQuery: undefined,
};

export default Tabs;
